import React from 'react';
import TermsComponent from '../../components/terms/components/TermsComponent';
import HeaderTags from '../../common/headerTags/HeaderTags';

const headerTags = {
    // Note: The title and og:title are also set within the TermsComponent to update based on the currently selected terms...
    title: 'Política de Privacidade e Termos de Uso', // max 60 char in total, ' | Antena 1' (11 chars) is automatically added by the Headers Tag and is truncated
    meta:
    {
        description: 'A rádio Antena 1 considera importante a privacidade de todos os visitantes de nosso site, deixando claro como são utilizados os dados eventualmente recebidos.',
        keywords: 'termo de uso, política de privacidade, termos, informações legais, informações jurídicas, direito do usuário',
        'og:title': 'Política de Privacidade e Termos de Uso',
        'og:description': 'A rádio Antena 1 considera importante a privacidade de todos os visitantes de nosso site, deixando claro como são utilizados os dados eventualmente recebidos.',
    },
};

const Termos = () => (
    <div className="pageWrapper tw-container tw-mx-auto tw-px-5">
        <HeaderTags title={headerTags.title} meta={headerTags.meta} />
        <TermsComponent />
    </div>
);

export default Termos;
